import async from 'components/Async';
import { accessType, role } from 'constants/index';

const IsImpersonatingPartnerPage = async(() => import('./IsImpersonatingPartnerPage'));

const impersonationRouteList = [
   {
      path: '/partner/impersonation',
      component: IsImpersonatingPartnerPage,
      isProtected: true,
      access: {
         type: accessType.role,
         value: {
            partner: [...role.partner.all],
            employer: [...role.employer.all],
         },
      },
   },
];

export default impersonationRouteList;
